import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ResponsiveService } from '@mmscan/design-system';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'mp-root',
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  templateUrl: './app.html',
  providers: [ConfirmationService, ResponsiveService],
})
export class App {}
